export default __webpack_public_path__ + "static/media/light_small.def17add.png";